import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
const LazyImage = ({ src, className }) => (
  <div>
    <LazyLoadImage
      //   alt={image.alt}
      height={"100%"}
      src={src} // use normal <img> attributes as props
      width={"100%"}
      effect="blur"
      className={className}
      //   wrapperProps={{
      //     // If you need to, you can tweak the effect transition using the wrapper style.
      //     style: { transitionDelay: "1s" },
      //   }}
    />
    <span>{}</span>
  </div>
);

export default LazyImage;
